import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'

import { ElevatedButton } from 'components/layout'
import { CenteredContent, Note } from 'components/misc'
import { SetupRPModal } from 'components/modals'
import { ACTIVITY_STATES, CONFIGURATION_KEYS } from 'constants/enums'
import MODALS from 'constants/layout/modals'
import { apiConfiguration, apiDashboard } from 'helpers/decorators/api'
import { modal } from 'helpers/decorators'
import { initialValuesRP } from 'models/residentialProjects'
import config from 'config'
import { connect } from 'react-redux'
import { isAssessorManagementEnabledForActivity } from '../../../helpers/assessorHelper'


@apiDashboard.apiResidentialProject({
  loaders: ['completion']
})
@modal.trigger()
@connect(state => ({
  awards: state.api.dashboard.awards
}))
@apiConfiguration()
class RPNew extends Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    residentialProject: PropTypes.object,
    params: PropTypes.object,
    colorClass: PropTypes.string,
    awards: PropTypes.array,
    configuration: PropTypes.object,
    onGetConfigurationValue: PropTypes.func
  }

  static defaultProps = {
    params: {}
  }

  componentWillMount = async() => {
    const { push, residentialProject, params } = this.props
    const id = get(residentialProject, 'id')
    const state = get(residentialProject, 'state.value')
    const awardList = get(this.props.awards, 'awards.list')

    if (id && ACTIVITY_STATES.setup.id !== state) {
      push(
        `${config.publicPath}/dashboard/awards/${params.awardId}/residential-project/${id}/report`
      )
    }

    let orgId = 0

    awardList && awardList.forEach(a => {
      if (a.id !== params.awardId) {
        orgId = get(a, 'organization.id')
      }
    })

    if(orgId) {
      await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.assessorMandatory.id, orgId, true)
    }
  }

  handleOpenNewRP = () => this.props.onOpen(MODALS.ADD_RESIDENTIAL_PROJECT)

  render() {
    const { residentialProject, colorClass, params, configuration } = this.props

    const state = get(residentialProject, 'state.value')

    const isAssessorDetailsMandatory = get(configuration, `values.${CONFIGURATION_KEYS.assessorMandatory.id}.booleanValue`)

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(residentialProject)

    return (
      <div style={{ padding: '25px 10px 75px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-lg-offset-1">
              {ACTIVITY_STATES.setup.id === state &&
                <CenteredContent
                  flex
                  textAlign
                  style={{ marginTop: '40px', flexDirection: 'column' }}
                >
                  <Note margin="10px 0 10px" fontSize="1.6rem" padding="0 15px">
                    <FormattedMessage
                      id="label.going_on_residential_gives_chance"
                      defaultMessage="Going on a residential gives you the chance to learn how to work with people from different backgrounds and build confidence living in new environments."
                    />
                  </Note>
                  <Note margin="10px 0 40px" fontSize="1.6rem" padding="0 15px">
                    <FormattedMessage
                      id="label.there_are_loads_of_exciting_possibilities"
                      defaultMessage="There are loads of exciting possibilities and opportunities, so choose something which you will find really fulfilling."
                    />
                  </Note>
                  <ElevatedButton
                    colorClass={colorClass}
                    uppercase
                    rounded
                    padded
                    extraWide
                    onClick={this.handleOpenNewRP}
                    intlKey="button.setup_residential"
                  >
                    Set up residential project
                  </ElevatedButton>
                </CenteredContent>}
            </div>
          </div>
        </div>

        <SetupRPModal
          id={get(residentialProject, 'id')}
          modalId={MODALS.ADD_RESIDENTIAL_PROJECT}
          initialValues={initialValuesRP(residentialProject)}
          params={params}
          isAssessorDetailsMandatory={isAssessorDetailsMandatory}
          isAssessorManagementEnabled={isAssessorManagementEnabled}
        />
      </div>
    )
  }
}

export default RPNew
